<template>
	<div>
		<div class="text-xs-center">
			<img
				v-if="value && enablePreview"
				:src="!(value instanceof fileType) ? 'data:image/png;base64,' + value : imageUrl"
				ref="imageUrl"
				@click="onPickFile"
				style="cursor: pointer; max-width: 100%; max-height: 10em;"
			>
			<p @click="onPickFile"></p>
			<v-btn class="ma-0" block @click="onPickFile" v-if="!imageUrl">
				<v-icon left>add</v-icon>
				{{ selectLabel }}
			</v-btn>
		</div>
		<v-layout row wrap class="mb-2">
			<v-btn class="ma-0" block @click="onPickFile" v-if="imageUrl">
				<v-icon left>edit</v-icon>
				{{ selectLabel }}
			</v-btn>
			<v-btn class="ma-0 error icon" @click="removeFile" v-if="imageUrl && hasRemoveButton">
				<v-icon>delete</v-icon>
			</v-btn>
			<input type="file" ref="image" name="image" :accept="accept" @change="onFilePicked">
		</v-layout>
	</div>
</template>

<script>
	/**
	 * Composant d'uploader de fichier.
	 */
	export default {
		props: {
			value: {
			},
			accept: {
				type: String,
				default: '*'
			},
			selectLabel: {
				type: String,
				default: 'Select a file'
			},
			hasRemoveButton: {
				type: Boolean,
				default: true
			},
			removeLabel: {
				type: String,
				default: 'Remove'
			},
			enablePreview: {
				type: Boolean,
				default: true
			}
		},

		data() {
			return {
				imageUrl: '',
				fileType: File
			};
		},

		watch: {
			value(v) {
				this.imageUrl = v;
			}
		},

		mounted() {
			this.imageUrl = this.value;
		},

		methods: {
			onPickFile() {
				this.$refs.image.click();
			},

			onFilePicked(event) {
				const files = event.target.files || event.dataTransfer.files;

				if (files && files[0]) {
					const filename = files[0].name;

					if (filename && filename.lastIndexOf('.') <= 0) {
						return;
					}

					const fileReader = new FileReader();
					fileReader.addEventListener('load', () => {
						this.imageUrl = fileReader.result;
					});
					fileReader.readAsDataURL(files[0]);

					this.$emit('input', files[0]);
				}
			},

			removeFile() {
				this.imageUrl = '';
				this.$emit('input', '');
			}
		}
	};
</script>

<style scoped>
input[type="file"] {
	position: absolute;
	left: -99999px;
}
</style>
